// Helpers shared by views

export function formatPhonePretty(phone: string): string {
  // Accepts +4941037044937 or 4941037044937 -> "+49 4103 7044937"
  if (!phone) return "";
  const trimmed = phone.replace(/[^\d+]/g, "");
  const digits = trimmed.startsWith("+") ? trimmed.slice(1) : trimmed;
  if (digits.startsWith("49") && digits.length > 5) {
    // crude DE prettify
    const rest = digits.slice(2);
    return `+49 ${rest.slice(0, 4)} ${rest.slice(4)}`.trim();
  }
  return phone;
}

export function formatTimestamp(ts: any): string {
  if (!ts) return "—";
  try {
    let date: Date | null = null;
    if (typeof ts === "string") date = new Date(ts);
    else if (typeof ts === "number") date = new Date(ts);
    else if (ts && typeof ts === "object") {
      // Firestore Timestamp from JSON: { _seconds, _nanoseconds } or { seconds, nanoseconds }
      const secs = ts._seconds ?? ts.seconds;
      if (typeof secs === "number") date = new Date(secs * 1000);
    }
    if (!date || isNaN(date.getTime())) return "—";
    return date.toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

export function chapterNumber(title: string): number {
  const n = parseInt((title || "").split(" ")[0], 10);
  return isNaN(n) ? 9999 : n;
}

export function chapterTitleWithoutNumber(title: string): string {
  const parts = (title || "").split(" ");
  if (parts.length <= 1) return title;
  // Drop the leading numeric token if it's present.
  return Number.isFinite(parseInt(parts[0], 10))
    ? parts.slice(1).join(" ")
    : title;
}

const ROMAN_PAIRS: Array<[number, string]> = [
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"],
];

export function toRoman(n: number): string {
  if (!Number.isFinite(n) || n < 1 || n > 39) return String(n);
  let value = Math.floor(n);
  let out = "";
  for (const [v, sym] of ROMAN_PAIRS) {
    while (value >= v) {
      out += sym;
      value -= v;
    }
  }
  return out;
}

export function chapterStatus(score: number, contentLength: number): {
  label: string;
  className: string;
} {
  if (score >= 80) return { label: "Reich an Inhalt", className: "badge-green" };
  if (score >= 30 || contentLength > 300)
    return { label: "In Bearbeitung", className: "badge-yellow" };
  return { label: "Noch leer", className: "badge-gray" };
}
